export enum WorkflowStepType {
  Approval = 'APPROVAL',
  Handoff = 'HANDOFF',
}
